<template>
  <div id="app">
    <div class="inner-container">
      <router-view v-if="isRouterAlive" />
    </div>
  </div>
</template>

<script>
import utilFile from "@/ace/ace.js";
export default {
  provide() {
    return {
      reload: this.reload
    };
  },
  metaInfo() {
    return {
      title: this.seotitle,
      meta: [
        {
          name: "keyWords",
          content: this.seokeyword
        },
        {
          name: "description",
          content: this.seodescription
        }
      ]
    };
  },
  data() {
    return {
      isRouterAlive: true,
      seotitle: "",
      seokeyword: "",
      seodescription: ""
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
    titlefunc() {
      this.$axios({
        method: "post",
        url: `/api/home.config`,
        data: {},
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        let data = JSON.parse(utilFile.decrypt(res.data.data));
        this.seotitle = data.seo_title;
        this.seokeyword = data.seo_keyword;
        this.seodescription = data.seo_description;
      });
    }
  },
  mounted() {
    this.titlefunc();
  }
};
</script>
<style>
#app {
  font-family: "微软雅黑", "sans-serif", "Arial", "Lucida Grande",
    "Lucida Sans Unicode", "STHeiti", "Helvetica", "Verdana";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  overflow: hidden;
}

* {
  margin: 0;
  padding: 0;
}
a {
  text-decoration: none;
}
li {
  list-style: none;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
img {
  border: 0;
  border: 0;
  width: 100%;
  max-height: 100%;
  display: block;
}
.clear {
  clear: both;
}
.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}
.clearfix {
  *zoom: 1;
}
html,
body {
  color: #555;
  width: 100%;
  height: 100%;
  font-family: "微软雅黑", "sans-serif", "Arial", "Lucida Grande",
    "Lucida Sans Unicode", "STHeiti", "Helvetica", "Verdana";
  font-size: 14px;
}
body {
  background-color: #f9fafc;
}
em,
i {
  font-style: normal;
}

a,
input,
select,
textarea {
  cursor: pointer;
  border: 0;
  outline: none;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: 300;
  line-height: 1em;
}

p {
  line-height: 1em;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}

.containers {
  width: 1196px;
  margin: auto;
}

.pageing {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 60px;
  margin-top: 60px;
  cursor: pointer;
}

.pageing span {
  font-size: 14px;
  color: #313131;
}
.pageing .el-pagination.is-background.el-pagination--small .btn-next,
.pageing .el-pagination.is-background.el-pagination--small .btn-prev,
.pageing .el-pagination.is-background.el-pagination--small .el-pager li {
  margin: 0 15px;
  background-color: transparent;
  width: 32px;
  height: 32px;
  line-height: 32px;
  color: #52649b;
}

.pageing .el-pagination.is-background.el-pagination--small .btn-next,
.pageing .el-pagination.is-background.el-pagination--small .btn-prev {
  width: 43px;
}

.pageing .el-pagination.is-background .el-pager li:not(.disabled).active {
  border-radius: 50%;
  background-color: #4d555d;
  color: #c9ced3;
}

.pageing .el-pagination.is-background .btn-next.disabled span,
.pageing .el-pagination.is-background .btn-next:disabled span,
.pageing .el-pagination.is-background .btn-prev.disabled span,
.pageing .el-pagination.is-background .btn-prev:disabled span,
.pageing .el-pagination.is-background .el-pager li.disabled span{
  color: #c9ced3!important;
}

.pageing .el-pagination button,
.el-pagination span:not([class*="suffix"]) {
  line-height: 32px;
  height: 32px;
  color: #000000;
}
.pageing .el-pagination--small button,
.pageing .el-pagination--small span:not([class*="suffix"]) {
  height: 32px;
  line-height: 32px;
}

.pageing .spansx.on{
  color: #c9ced3!important;
}

.inner-container {
  width: calc(100vw + 24px);
}
</style>
